import { render, staticRenderFns } from "./ContactPicker.vue?vue&type=template&id=6bc5c7ba"
import script from "./ContactPicker.vue?vue&type=script&lang=js"
export * from "./ContactPicker.vue?vue&type=script&lang=js"
import style0 from "./ContactPicker.vue?vue&type=style&index=0&id=6bc5c7ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports